import { IVehicleMapPanelProps } from "interfaces/components/Map/IVehicleMapPanelProps";
import "./mapPanel.scss";
import {
  Card, Row, Col, CloseButton, Badge
} from "react-bootstrap";
import { Spinner } from "@whitespace/whitespace-ui";
import { useAmplifyREST } from "hooks/useAmplifyREST";
import IHwrcSiteWorkOrderViewModel from "interfaces/IHwrcSiteWorkOrderViewModel";
import IGetHwrcSiteWorkOrders from "interfaces/Response/IGetHwrcSiteWorkOrders";
import React, { useState, useEffect } from "react";
import MapWorkOrderPane from "./MapWorkOrderPane";

const VehicleMapPanel = ({
  onClose,
  vehicleDetails,
  id,
  isSendingHandler,
  addToExceptionsHandler
}: IVehicleMapPanelProps) => {
  const [workOrders, setWorkOrders] = useState<IHwrcSiteWorkOrderViewModel[]>(
    []
  );

  const {
    isSending: getVehicleWorkOrdersIsSending,
    errors: getVehicleWorkOrdersErrors,
    data: getVehicleWorkOrdersData,
    sendRequest: getVehicleWorkOrdersSendRequest
  } = useAmplifyREST();

  useEffect(() => {
    if (id) {
      setWorkOrders([]);
      getVehicleWorkOrdersSendRequest(
        `vehicles/${id}/workorders/incomplete`,
        "GET"
      );
    }
  }, [getVehicleWorkOrdersSendRequest, id]);

  useEffect(() => {
    isSendingHandler(getVehicleWorkOrdersIsSending);
  }, [getVehicleWorkOrdersIsSending, isSendingHandler]);

  useEffect(() => {
    if (getVehicleWorkOrdersErrors) {
      addToExceptionsHandler(getVehicleWorkOrdersErrors);
    }
  }, [getVehicleWorkOrdersErrors, addToExceptionsHandler]);

  useEffect(() => {
    if (getVehicleWorkOrdersData as IGetHwrcSiteWorkOrders) {
      setWorkOrders(getVehicleWorkOrdersData.workOrders);
    }
  }, [getVehicleWorkOrdersData, setWorkOrders]);

  const renderWorkOrders = () => {
    if (workOrders) {
      return React.Children.toArray(
        workOrders.map((workOrder: IHwrcSiteWorkOrderViewModel) => (
          <MapWorkOrderPane workOrder={workOrder} isVehicle sourceId={id} />
        ))
      );
    }

    return undefined;
  };

  return (
    <div className="d-flex flex-column map-panel map-panel-border">
      <Card className="flex-fill">
        <Card.Header data-testid="vehicle-card-header">
          Vehicle Details
          <CloseButton aria-label="Close" variant="white" onClick={onClose} />
        </Card.Header>
        <Card.Body className="side-darawer">
          <Row>
            <Col>
              <strong>
                <span data-testid="vehicle-name">Vehicle Name</span>
              </strong>
            </Col>
          </Row>

          <Row className="mb-2">
            <Col>{vehicleDetails && vehicleDetails.name}</Col>
          </Row>

          <Row>
            <Col>
              <strong>
                <span data-testid="vehicle-type">Vehicle Type</span>
              </strong>
            </Col>
          </Row>
          <Row className="mb-2">
            <Col>{vehicleDetails && vehicleDetails.type}</Col>
          </Row>

          <Row>
            <Col>
              <strong>
                <span data-testid="vehicle-status">Vehicle Status</span>
              </strong>
            </Col>
          </Row>
          <Row>
            <Col>{vehicleDetails && vehicleDetails.status}</Col>
          </Row>
        </Card.Body>
      </Card>
      <Card className="flex-grow-1">
        <Card.Header data-testid="vehicle-workorder-header">
          Work Orders
          <Spinner
            animation="grow"
            visible={getVehicleWorkOrdersIsSending}
            spinnerText="Loading"
            variant="info"
          />
          {!getVehicleWorkOrdersIsSending && (
            <Badge className="float-end" data-testid="workorder-count">
              {workOrders && workOrders.length}
            </Badge>
          )}
        </Card.Header>
        <Card.Body
          className="work-orders-overflow-scroll side-darawer"
          style={{ maxHeight: "34.5vh" }}
        >
          {workOrders && renderWorkOrders()}
        </Card.Body>
      </Card>
    </div>
  );
};

export default VehicleMapPanel;
